module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGSEAFOOD2-d378aac0ea3d47760e6b434867ae9862.png";